"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbaToRgb = exports.hexToRgb = void 0;
function getCompleteHexColor(hexColor) {
    if (hexColor.length === 3) {
        var _a = hexColor.split(''), r = _a[0], g = _a[1], b = _a[2];
        return "" + (r + r) + (g + g) + (b + b);
    }
    return hexColor;
}
function hexToRgb(hexColor) {
    var hexWithoutHash = hexColor.slice(1);
    var completeHexColor = getCompleteHexColor(hexWithoutHash);
    var hexToDecimal = parseInt(completeHexColor, 16);
    var r = (hexToDecimal >> 16) & 255;
    var g = (hexToDecimal >> 8) & 255;
    var b = hexToDecimal & 255;
    return {
        r: r,
        g: g,
        b: b
    };
}
exports.hexToRgb = hexToRgb;
function rgbaToRgb(r, g, b, a) {
    var backR = 255;
    var backG = 255;
    var backB = 255;
    var alpha = 1 - a;
    return {
        r: Math.round((alpha * backR) + (a * r)),
        g: Math.round((alpha * backG) + (a * g)),
        b: Math.round((alpha * backB) + (a * b))
    };
}
exports.rgbaToRgb = rgbaToRgb;
